import moment from "moment";
import { API } from "../config";

export class Session {
  constructor() {
    this._isRefreshing = false;
    this._failedQueue = [];
  }

  processQueue = (error, token = null) => {
    this._failedQueue.forEach((promise) => {
      if (error) {
        promise.reject(error);
      } else {
        promise.resolve(token);
      }
    });

    this._failedQueue = [];
  }

  queue(value) {
    this._failedQueue.push(value);
  }

  isRefreshing() {
    return this._isRefreshing;
  }

  setRefreshing(value) {
    this._isRefreshing = value;
  }

  async refreshToken() {
    const v = JSON.parse(localStorage.getItem("jwt"));
    if (!v || !v.refreshToken) throw new Error("No refresh token available.");

    const url = API + "/v1/token";

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        refresh_token: v.refreshToken,
      }),
    });

    if (!response.ok) throw new Error("Failed to refresh token!");

    const rj = await response.json();

    localStorage.setItem(
      "jwt",
      JSON.stringify({
        ...v,
        refreshToken: rj.refresh_token,
        expiredAt: moment(rj.expired_at),
        token: rj.access_token,
        userId: v.userId,
      })
    );

    return rj.access_token;
  }

  retryWithRefreshToken = async (callback = null) => {
    try {
      if (this.isRefreshing()) {
        return await new Promise((resolve, reject) => {
          this._failedQueue.push({ resolve, reject });
        }).then(callback);
      }

      this.setRefreshing(true);

      const newToken = await this.refreshToken();
      this.setRefreshing(false);
      this.processQueue(null, newToken);

      return callback(newToken);
    } catch (err) {
      this.processQueue(err, null);
      return this.deleteSession();
    }
  }

  deleteSession() {
    localStorage.removeItem("jwt");
    return window.location.reload();
  }
}

export const session = new Session();

export const UNAUTHORIZED_MESSAGES = [
  "Authentication for your key is failed. Please make sure input the right key or contact info@biteship.com for more information.",
  "User information not found.",
  "User not found.",
];

export const TOKEN_EXPIRED_MESSAGE = [
  "Token is expired",
];
